import { ReactComponent as Google } from 'assets/icons/google-colored.svg';
import withSocialLogin from 'components/common/social-login-button/withSocialLogin';
import { AuthProvider } from 'store/api/userApi';

const GoogleLoginButton = withSocialLogin(AuthProvider.Google, Google, 'googleLogin');

export default GoogleLoginButton;
